import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../lib/api"
import { getAdminLoginPath, getChapterIntakeUploadPath } from "../lib/adminHost"
import { clearAdminSession, getAuthScope, isDummyAuthToken } from "../lib/adminAuth"

export type ChapterIntakeSession = {
  chapterSlug: string
  contactEmail: string
  accessEmail: string
  expiresAt: string
  uploadCount: number
  maxUploads: number
}

export function useChapterIntakeAuth() {
  const [session, setSession] = useState<ChapterIntakeSession | null>(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const check = async () => {
      const token = localStorage.getItem("auth_token")
      const scope = getAuthScope()

      if (!token || scope !== "chapter-intake") {
        clearAdminSession()
        navigate(`${getAdminLoginPath()}?return=${encodeURIComponent(getChapterIntakeUploadPath())}`)
        return
      }

      if (isDummyAuthToken(token)) {
        setSession({
          chapterSlug: "dublin",
          contactEmail: "dev@example.com",
          accessEmail: "dev@example.com",
          expiresAt: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(),
          uploadCount: 0,
          maxUploads: 50,
        })
        setLoading(false)
        return
      }

      try {
        const data = await apiClient.getChapterIntakeSession()
        setSession(data)
      } catch (error) {
        console.error("Chapter intake session check failed:", error)
        clearAdminSession()
        navigate(`${getAdminLoginPath()}?return=${encodeURIComponent(getChapterIntakeUploadPath())}`)
      } finally {
        setLoading(false)
      }
    }

    void check()
  }, [navigate])

  const logout = () => {
    clearAdminSession()
    navigate(getAdminLoginPath())
  }

  return { session, loading, logout }
}
